export const enContextHub = {
  title: "Context Hub",
  subtitle: "Manage system definitions and your personalized intelligence layer",
  tabs: {
    aria: "Context Hub sections",
    myPreferences: "My Preferences",
    learningHistory: "Learning History",
  },
  myPreferences: {
    roleProfile: {
      title: "Role & Profile",
      roleLabel: "Your Role",
    },
  },
} as const;
